import "core-js/modules/es.array.push.js";
export default {
  props: {
    rows: {
      type: Number,
      default: 4
    }
  },
  computed: {
    calcRows() {
      let calc = [];
      let i = 0;
      while (i < this.rows) {
        calc.push(i);
        i++;
      }
      return calc;
    }
  }
};